import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchWonDeals } from '../../../store/orders/action';
import MyOrders from './component';

const mapStateToProps = () => ({
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchWonDealsConnect: fetchWonDeals
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MyOrders);